import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=39a64bea&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=39a64bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a64bea",
  null
  
)

export default component.exports